// src/features/chat/components/ReplyIndicator.jsx

import React, { memo } from 'react';
import { Reply, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './ReplyIndicator.module.css';

const ReplyIndicator = memo(({ message, sender, onCancel }) => {
  const { t } = useTranslation();

  if (!message) return null;

  const isAssistant =
    sender?.isAssistant ||
    message.senderId === 'bot' ||
    message.senderId === 'assistant';
  const senderName = isAssistant
    ? (sender?.displayName || t('app_name') || t('chat.affin_icon'))
    : (sender?.displayName || t('chat.user'));

  return (
    <div className={styles.replyIndicator}>
      <Reply size={16} color="var(--accent-primary)" />
      <div className={styles.replyIndicatorInfo}>
        <div className={styles.replyToName}>
          {t('chat.replying_to')} {senderName}
        </div>
        <div className={styles.replyPreview}>
          {message.text || (message.images?.length > 0 ? t('chat.image') : '')}
        </div>
      </div>
      <button
        className={styles.cancelReply}
        onClick={onCancel}
        aria-label={t('chat.cancel_reply')}
      >
        <X size={16} />
      </button>
    </div>
  );
});

ReplyIndicator.displayName = 'ReplyIndicator';

export default ReplyIndicator;
